export const HostConfig = {
    Default: 'Default',
    Custom: 'Custom',
    None: 'None',
  }

